import "./features/robot-animation";
import "./home/cables";
import { bootProductSlider } from "./home/product-slider";

bootProductSlider();
